module.exports = __webpack_public_path__ + "img/status-unchecked.95c124c4.svg";